module.exports = {
      id: "icon-star-usage",
      viewBox: "0 0 30.754 29.435",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-star",
      toString: function () {
        return this.url;
      }
    }